import { render, staticRenderFns } from "./deleteContact.vue?vue&type=template&id=117c74de"
import script from "./deleteContact.vue?vue&type=script&lang=js"
export * from "./deleteContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports